import React, { Component } from "react";
export default class spinner extends Component {
  render() {
    return (
      <>
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-light" role="status"></div>
          <span className="text-light">Loading...</span>
        </div>
       
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </>
    );
  }
}
